/**
 * Place any jQuery/helper plugins in here.
 */

$(function () {
    /**
     Loading button
     #THE BUTTON
     <button class="btn btn-primary btn-block button-loader" data-loading-text="<i class='fa fa-spinner fa-spin'></i> My button with loader" type="submit">
     <i class="fal fa-sign-in"></i>
     My button
     </button>

     #START LOADING WITH CUSTOM MSG
     $('.button-loader').button('loading');

     #START LOADING WITH CUSTOM MSG
     $('.button-loader').button('reset');
     */

    (function($) {
        $.fn.button = function(action) {
            if (action === 'loading' && this.data('loading-text')) {
                this.data('original-text', this.html()).html(this.data('loading-text')).prop('disabled', true);
            }
            if (action === 'reset' && this.data('original-text')) {
                this.html(this.data('original-text')).prop('disabled', false);
            }
        };
    }(jQuery));

    /**
     * Checkbox tree for permission selecting
     */
    $('#tree :checkbox').on('click change', function (){
        if($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        } else {
            $(this).siblings('ul').find('input[type="checkbox"]').removeAttr('checked').removeAttr('disabled');
        }
    });

    $('#tree :checkbox').each(function () {
        if($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        }
    });

    /**
     * Disable submit inputs in the given form
     *
     * @param form
     */
    function disableSubmitButtons(form) {
        form.find('input[type="submit"]').attr('disabled', true);
        form.find('button[type="submit"]').attr('disabled', true);
    }

    /**
     * Enable the submit inputs in a given form
     *
     * @param form
     */
    function enableSubmitButtons(form) {
        form.find('input[type="submit"]').removeAttr('disabled');
        form.find('button[type="submit"]').removeAttr('disabled');
    }

    /**
     * Disable all submit buttons once clicked
     */
    $('form').not('.needs-validation').not('.jquery-validation').submit(function () {
        disableSubmitButtons($(this));
        return true;
    });

    /**
     * Add a confirmation to a delete button/form
     */
    $('body').on('submit', 'form[name=delete-item]', function(e) {
        e.preventDefault();

        Swal.fire({
            title: 'Are you sure you want to delete this item?',
            showCancelButton: true,
            confirmButtonText: 'Confirm Delete',
            cancelButtonText: 'Cancel',
            icon: 'warning'
        }).then((result) => {
            if (result.value) {
                this.submit()
            } else {
                enableSubmitButtons($(this));
            }
        });
    }).on('submit', 'form[name=confirm-item]', function (e) {
        e.preventDefault();

        Swal.fire({
            title: 'Are you sure you want to do this?',
            showCancelButton: true,
            confirmButtonText: 'Continue',
            cancelButtonText: 'Cancel',
            icon: 'warning'
        }).then((result) => {
            if (result.value) {
                this.submit()
            } else {
                enableSubmitButtons($(this));
            }
        });
    }).on('click', 'a[name=confirm-item]', function (e) {
        /**
         * Add an 'are you sure' pop-up to any button/link
         */
        e.preventDefault();

        Swal.fire({
            title: 'Are you sure you want to do this?',
            showCancelButton: true,
            confirmButtonText: 'Continue',
            cancelButtonText: 'Cancel',
            icon: 'info',
        }).then((result) => {
            result.value && window.location.assign($(this).attr('href'));
        });
    }).on('click', '[data-livewire-confirm-delete]', function (e) {
        /**
         * Add confirm dialog on livewire table rows
         * Ex: <button type="button" class="btn btn-danger btn-sm" title="Remove" data-livewire-confirm-delete='@json(['component'=>'backend.banking-transfers-table', 'event'=>'removeTransfer', 'params'=>[$row->id]])'><i class="fa fa-trash"></i> {{ $row->id }}</button>
         */
        var data = $(this).data('livewire-confirm-delete');
        if (data.component && data.event && data.params) {
            Swal.fire({
                title: 'Are you sure you want to delete this item?',
                showCancelButton: true,
                confirmButtonText: 'Confirm Delete',
                cancelButtonText: 'Cancel',
                icon: 'warning'
            }).then((result) => {
                if (result.value) {
                    Livewire.emitTo(data.component, data.event, data.params);
                }
            });
        }
    });

    // Remember tab on page load
    $('a[data-toggle="tab"], a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
        let hash = $(e.target).attr('href');
        history.pushState ? history.pushState(null, null, hash) : location.hash = hash;
    });

    let hash = window.location.hash;
    if (hash) {
        $('.nav-link[href="'+hash+'"]').tab('show');
    }

    // Enable tooltips everywhere
    $('[data-toggle="tooltip"]').tooltip({
        boundary: 'window',
        container: 'body'
    });

    if (typeof Livewire !== 'undefined') {
        Livewire.hook('message.processed', (message, component) => {
            $('[data-toggle="tooltip"]').tooltip({
                boundary: 'window',
                container: 'body'
            })
        })
    }


    $('.select2').each(function (index, el) {
        var $modal = $(el).closest('.modal');
        var placeholder = $(el).data('placeholder') || 'Select';
        if ($modal.length) {
            $(el).select2({
                theme: 'bootstrap4',
                placeholder: placeholder,
                dropdownParent: '#'+$modal.attr('id')
            });
        } else {
            $(el).select2({
                theme: 'bootstrap4',
                placeholder: placeholder
            });
        }
    });

    if ($.validator) {
        /**
         * =======================================
         * Form Validation
         * =======================================
         */
        $.validator.setDefaults({
            errorElement: 'span',
            errorPlacement: function (error, element) {
                error.addClass('invalid-feedback');
                if (element.closest('.input-group').length) {
                    error.insertAfter(element.closest('.input-group'));
                } else if (element.closest('.form-group').find('.validation').length) {
                    element.closest('.form-group').find('.validation').html(error);
                } else {
                    error.insertAfter(element);
                }
            },
            highlight: function (element, errorClass, validClass) {
                $( element ).addClass( "is-invalid" ).removeClass( "is-valid" );
            },
            unhighlight: function (element, errorClass, validClass) {
                $( element ).addClass( "is-valid" ).removeClass( "is-invalid" );
            },
            ignore: ".ignore-validation"
        });

        $.validator.addMethod('positive', function (value, element) {
            return this.optional(element) || Number(value) > 0;
        }, jQuery.validator.messages.positive || 'Value must be greater then zero');

        $.validator.addMethod("crypto-address", function(value, element) {
            var currency = $(element).data('crypto-address-currency');
            var warning_message = $(element).data('warning-crypto-address');
            if (!currency) {
                // No validate if empty
                if (warning_message) {
                    $(element).closest('.form-group').find('.validation').html('<span class="text-warning small mt-2">'+warning_message+'</span>');
                }
                return true;
            }

            value = value.replace(/\s+/g, "");
            var networks = ($(element).data('crypto-address-networks') || 'prod').split('|');
            var isValid1 = WAValidator.validate(value, currency, 'prod');
            var isValid2 = WAValidator.validate(value, currency, 'testnet');
            var isValid = isValid1;
            if (_.includes(networks, 'testnet')) {
                isValid = isValid1 || isValid2;
            }

            return this.optional(element) || isValid === true;
        });

        $.validator.addMethod("crypto-address-some", function(value, element) {
            var source_address = $(element).data('crypto-address');
            var destination_address = value.replace(/\s+/g, "");
            return this.optional(element) || source_address !== destination_address;
        });

        $.validator.addMethod("uk-sort-code", function(value, element) {
            // It will strictly match only input in the form XX-XX-XX or XXXXXX where X are digits, and will exclude 00-00-00, 000000 along with any other cases (e.g. XX-XXXX or XXXX-XX).
            var sortCodeRegEx = /^(?!(?:0{6}|00-00-00))(?:\d{6}|\d\d-\d\d-\d\d)$/;
            return this.optional(element) || sortCodeRegEx.test(value);
        });

        $.validator.addMethod("uk-account-number", function(value, element) {
            var accRegEx = /^\d{7,8}$/;
            return this.optional(element) || accRegEx.test(value);
        });

        $.validator.addMethod("ibantools", function(value, element) {
            const iban = window.ibantools.electronicFormatIBAN(value); // 'NL91ABNA0517164300'
            return this.optional(element) || window.ibantools.isValidIBAN(iban);
        });

        $.validator.addMethod('IP4Checker', function(value) {
            return value.match(/^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/);
        }, 'Invalid IP address');

        $( 'form.jquery-validation' ).each( function( i, el ) {
            var $form = $( this );
            if ($.fn.validate) {
                $form.validate({
                    onkeyup: false
                });
            }
        });
    }

});

window.addEventListener('swal',function(e){
    Swal.fire(e.detail);
});

// https://github.com/nyx-solutions/jquery-numeric
$(function () {
    $('.numeric').numeric();

    $('.integer').numeric(
        false,
        function () {
            alert('Integers only');
            this.value = '';
            this.focus();
        }
    );

    $('.positive').numeric(
        {negative: false},
        function () {
            alert('No negative values');
            this.value = '';
            this.focus();
        }
    );

    $('.positive-integer').numeric(
        {decimal: false, negative: false},
        function () {
            alert('Positive integers only');
            this.value = '';
            this.focus();
        }
    );

    $('.decimal-2-places').numeric({decimalPlaces: 2});

    $('.alternative-decimal-separator').numeric({altDecimal: ','});

    $('.alternative-decimal-separator-reverse').numeric({altDecimal: '.', decimal: ','});
});
